import React, { Fragment } from 'react'
import toast from 'react-hot-toast'
import _ from 'lodash'

import { DataGrid } from '@mui/x-data-grid'
import { Box, Card, IconButton, Switch, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import PencilOutline from 'mdi-material-ui/PencilOutline'

import APICall from 'network/APICall'
import EndPoints from 'network/Endpoints'

const GeneralSettingList = props => {
  const {
    fetchGeneralSetting,
    handleOpen,
    handleProgramStatusChange,
    generalList,
    permission,
    role
  } = props
  const theme = useTheme()

  const handleClick = status => {
    handleProgramStatusChange(!status)
  }

  const handleRowOptionsClose = id => {
    handleOpen(id)
  }

  const handalId = (id, status, e) => {
    if (id === 1) {
      handleClick(status)
    } else {
      const payload = {
        isEnable: e.target.checked
      }
      APICall('post', payload, EndPoints.enableImsak)
        .then(response => {
          fetchGeneralSetting()
          const { isError, message } = response.data
          if (isError) {
            toast.error(message)
            return
          }
          toast.success(message)
        })
        .catch(e => toast.error(e))
    }
  }

  const handleLiveVideo = e => {
    const payload = {
      status: e.target.checked
    }
    APICall('post', payload, EndPoints.updateVideoStatus)
      .then(response => {
        fetchGeneralSetting()
        const { isError, message } = response.data
        if (!isError) {
          toast.success(message)
        } else {
          toast.error(message)
        }
      })
      .catch(e => toast.error(e))
  }

  const columns = [
    {
      flex: 1,
      minWidth: 150,
      field: 'title',
      headerName: 'title'
    },
    {
      flex: 2,
      minWidth: 200,
      field: 'live_program',
      headerName: '',
      renderCell: ({ row }) => {
        const program = row.live_program
        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            <Typography
              variant='body2'
              sx={{ color: 'text.primary', fontWeight: 600 }}
            >
              {program}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 1.5,
      minWidth: 150,
      field: 'program_title',
      headerName: 'Program'
    },
    {
      flex: 1,
      minWidth: 120,
      field: 'is_video_live',
      headerName: 'Live Video',
      renderCell: ({ row }) => {
        const status = row.is_video_live
        if (row.id === 2) {
          return
        }

        return (
          <Switch
            checked={status}
            size={'small'}
            style={{ color: theme.palette.primary.light }}
            onChange={e => handleLiveVideo(e)}
          />
        )
      }
    },
    {
      flex: 1,
      minWidth: 120,
      field: 'is_live_program',
      headerName: 'Live Program',
      renderCell: ({ row }) => {
        const status = row.is_live_program
        const imsak = row.is_imsak
        return (
          <Switch
            checked={row.id === 2 ? imsak : status}
            size={'small'}
            style={{ color: theme.palette.primary.light }}
            onChange={e => handalId(row.id, status, e)}
          />
        )
      }
    },
    {
      flex: 0.5,
      minWidth: 100,
      field: 'action',
      headerName: 'Actions',
      renderCell: ({ row }) => {
        if (row.id === 2) {
          return
        }
        return (
          <>
            {((permission.edit && role === '2') || role === '1') && (
              <IconButton onClick={() => handleRowOptionsClose(row.id)}>
                <PencilOutline fontSize='small' />
              </IconButton>
            )}
          </>
        )
      }
    }
  ]
  const removeaction =
    !permission.edit && role === '2' ? _.dropRight(columns, 2) : columns
  return (
    <Fragment>
      <Card sx={{ width: '100%', overflowInline: 'hidden' }}>
        <DataGrid
          hideFooterPagination={true}
          autoHeight
          columns={removeaction}
          rows={generalList}
          disableColumnFilter={true}
          disableColumnSelector={true}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          sx={{
            '.MuiTablePagination-displayedRows': {
              marginTop: '1rem'
            },
            '.MuiTablePagination-selectLabel': {
              marginTop: '1.1rem'
            },
            '.MuiInputBase-root': {
              marginTop: '0.2rem'
            }
          }}
        />
      </Card>
    </Fragment>
  )
}

export default GeneralSettingList
